/* menu.js 导航菜单 */

export default [
  // 布局页 (id=1)
  {
    path: "/layout",
    name: "Layout",
    title: "Dashboard",
    component: "layout/index",
    icon: "el-icon-house",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 欢迎页 Welcome (id=101)
      {
        path: "/layout/welcome",
        name: "Welcome",
        title: "控制台",
        component: "welcome/index",
        icon: "el-icon-monitor",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 1,
        type: 2,
        auth: "",
        id: 101, // 一级子节点ID：父ID+01 格式
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 1,
  },

  // 系统管理 (id=2)
  {
    path: "/system",
    name: "System",
    title: "系统管理",
    component: "layout/index",
    icon: "el-icon-setting",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 系统信息 (id=201)
      {
        path: "/system/config/index",
        name: "System_Config",
        title: "系统信息",
        component: "system/config/index",
        icon: "el-icon-setting",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 201,
      },
      // 管理员 (id=202)
      {
        path: "/system/admin/index",
        name: "System_Admin",
        title: "管理员",
        component: "system/admin/index",
        icon: "el-icon-s-custom",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 202,
      },
      // 角色管理 (id=203)
      {
        path: "/system/role/index",
        name: "System_Role",
        title: "角色管理",
        component: "system/role/index",
        icon: "el-icon-postcard",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 203,
      },
      // 商户角色管理 (id=324)
      {
        path: "/merchant/role/index",
        name: "Merchant_Role",
        title: "商户角色管理",
        component: "merchant/role/index",
        icon: "el-icon-postcard",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 324,
      },
      // 用户身份列表 (id=204)
      {
        path: "/user/role/index",
        name: "User_Role_Index",
        title: "用户角色列表",
        component: "user/role/index",
        icon: "el-icon-s-promotion",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 204,
      },
      // 用户角色权限列表 (id=205)
      {
        path: "/user/role_auth/index/:role_id",
        name: "User_Role_Auth_Index",
        title: "用户角色权限列表",
        component: "user/role_auth/index",
        icon: "el-icon-s-promotion",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 3,
        auth: "",
        id: 205,
      },
      // 菜单管理 (id=206)
      {
        path: "/system/menu/index",
        name: "System_Menu",
        title: "菜单管理",
        component: "system/menu/index",
        icon: "el-icon-s-operation",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 206,
      },
      // 传送点列表 (id=207)
      {
        path: "/system/city/index",
        name: "System_City",
        title: "传送点列表",
        component: "system/city/index",
        icon: "el-icon-office-building",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 207,
      },
      // 轮播图管理 (id=208)
      {
        path: "/system/swiper/index",
        name: "System_Swiper_Index",
        title: "轮播图管理",
        component: "system/swiper/index",
        icon: "el-icon-picture",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 208,
      },
      // 公告管理 (id=209)
      {
        path: "/system/notice/index",
        name: "System_Notice_Index",
        title: "公告管理",
        component: "system/notice/index",
        icon: "el-icon-message-solid",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 209,
      },
      // 协议管理 (id=210)
      {
        path: "/system/agreement/index",
        name: "System_Agreement_Index",
        title: "资质协议管理",
        component: "system/agreement/index",
        icon: "ivu-icon ivu-icon-logo-angular",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 210,
      },
      // 营销管理 (id=211)
      {
        path: "/marketing",
        name: "Marketing",
        title: "营销管理",
        component: "marketing/index",
        icon: "ivu-icon ivu-icon-ios-pulse",
        isLayout: false,
        isRouter: true,
        isMenu: true,
        children: [
          // 优惠券列表 (id=21101)
          {
            path: "/marketing/coupon/index",
            name: "Marketing_Coupon_Index",
            title: "优惠券列表",
            component: "marketing/coupon/index",
            icon: "ivu-icon ivu-icon-logo-skype",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 211,
            type: 2,
            auth: "",
            id: 21101,
          },
          // 优惠券领取记录列表 (id=21102)
          {
            path: "/marketing/coupon/record/index/:id",
            name: "Marketing_Coupon_Record_Index",
            title: "优惠券领取记录",
            component: "marketing/coupon/record/index",
            icon: "ivu-icon ivu-icon-logo-skype",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 211,
            type: 2,
            auth: "",
            id: 21102,
          },
          // 激活码列表 (id=21103)
          {
            path: "/marketing/user_role/index",
            name: "Marketing_User_Role_Index",
            title: "激活码列表",
            component: "marketing/user_role/index",
            icon: "ivu-icon ivu-icon-logo-vimeo",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 211,
            type: 2,
            auth: "",
            id: 21103,
          },
          // 极分充值列表 (id=21104)
          {
            path: "/marketing/recharge/index",
            name: "Marketing_Recharge_Index",
            title: "极分充值列表",
            component: "marketing/recharge/index",
            icon: "ivu-icon ivu-icon-logo-euro",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 211,
            type: 2,
            auth: "",
            id: 21104,
          },
        ],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 211,
      },
      // 订单管理 (id=212)
      {
        path: "/order",
        name: "Order",
        title: "订单管理",
        component: "order/init",
        icon: "el-icon-s-order",
        isLayout: false,
        isRouter: true,
        isMenu: true,
        children: [
          // 订单列表 (id=21201)
          {
            path: "/order/index",
            name: "Order_Index",
            title: "订单列表",
            component: "order/index",
            icon: "el-icon-s-order",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 212,
            type: 2,
            auth: "",
            id: 21201,
          },
        ],
        role: [],
        parentId: 2,
        type: 1,
        auth: "",
        id: 212,
      },
      // 峡谷管理 (id=216)
      {
        path: "/system/canyon/index",
        name: "System_Canyon",
        title: "峡谷管理",
        component: "system/canyon/index",
        icon: "el-icon-postcard",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 216,
      },
      // 英雄管理 (id=213)
      {
        path: "/system/hero/index",
        name: "System_Hero",
        title: "英雄管理",
        component: "system/hero/index",
        icon: "el-icon-postcard",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 213,
      },
      // 激活码列表 (id=214)
      {
        path: "/system/hero/code/index/:hero_id",
        name: "System_Hero_Code_Index",
        title: "英雄激活码列表",
        component: "system/hero_code/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 214,
      },
      // 英雄匹配度报告列表 (id=215)
      {
        path: "/system/hero/record/index",
        name: "System_Hero_Record_Index",
        title: "英雄匹配度报告列表",
        component: "system/hero_record/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 215,
      },
      // 打印机列表 (id=217)
      {
        path: "/system/printer/index",
        name: "System_Printer_Index",
        title: "打印机列表",
        component: "system/printer/index",
        icon: "ivu-icon ivu-icon-md-print",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 2,
        type: 2,
        auth: "",
        id: 217,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 2,
  },

  // 商户管理 (id=3)
  {
    path: "/merchant",
    name: "Merchant",
    title: "商户管理",
    component: "layout/index",
    icon: "ivu-icon ivu-icon-ios-appstore-outline",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 商户列表 (id=301)
      {
        path: "/merchant/index",
        name: "Merchant_Index",
        title: "商户列表",
        component: "merchant/index",
        icon: "ivu-icon ivu-icon-ios-appstore",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 301,
      },
      // 添加商户信息 (id=302)
      {
        path: "/merchant/detail/index",
        name: "Merchant_Detail_Insert_Index",
        title: "添加商户信息",
        component: "merchant/detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 302,
      },
      // 编辑商户信息 (id=303)
      {
        path: "/merchant/detail/index/:id",
        name: "Merchant_Detail_Update_Index",
        title: "编辑商户信息",
        component: "merchant/detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 303,
      },
      // 咖啡店列表 (id=304)
      {
        path: "/merchant/coffee/index",
        name: "Merchant_Coffee_Index",
        title: "咖啡店列表",
        component: "merchant/coffee/index",
        icon: "ivu-icon ivu-icon-ios-cafe",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 304,
      },
      // 添加咖啡店信息 (id=305)
      {
        path: "/merchant/coffee/detail/index",
        name: "Merchant_Coffee_Detail_Insert_Index",
        title: "添加咖啡店信息",
        component: "merchant/coffee_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 305,
      },
      // 编辑咖啡店信息 (id=306)
      {
        path: "/merchant/coffee/detail/index/:id",
        name: "Merchant_Coffee_Detail_Update_Index",
        title: "编辑商户信息",
        component: "merchant/coffee_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 306,
      },
      // 小镇列表 (id=307)
      {
        path: "/merchant/town/index",
        name: "Merchant_Town_Index",
        title: "小镇列表",
        component: "merchant/town/index",
        icon: "el-icon-office-building",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 307,
      },
      // 添加小镇信息 (id=308)
      {
        path: "/merchant/town/detail/index",
        name: "Merchant_Town_Detail_Insert_Index",
        title: "添加小镇信息",
        component: "merchant/town_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 308,
      },
      // 编辑小镇信息 (id=309)
      {
        path: "/merchant/town/detail/index/:id",
        name: "Merchant_Town_Detail_Update_Index",
        title: "编辑小镇信息",
        component: "merchant/town_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 309,
      },
      // 小镇-门店列表 (id=310)
      {
        path: "/merchant/town_shop/index/:merch_id/:town_id",
        name: "Merchant_Town_Shop_Index",
        title: "小镇-门店列表",
        component: "merchant/town_shop/index",
        icon: "el-icon-office-building",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 310,
      },
      // 添加小镇门店信息 (id=311)
      {
        path: "/merchant/town_shop/detail/index/:merch_id/:town_id/:shop_type",
        name: "Merchant_Town_Shop_Detail_Insert_Index",
        title: "添加小镇门店信息",
        component: "merchant/town_shop_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 311,
      },
      // 编辑小镇门店信息 (id=312)
      {
        path: "/merchant/town_shop/detail/index/:merch_id/:town_id/:shop_type/:id",
        name: "Merchant_Town_Shop_Detail_Update_Index",
        title: "编辑小镇门店信息",
        component: "merchant/town_shop_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 312,
      },
      // 企业列表 (id=313)
      {
        path: "/merchant/company/index",
        name: "Merchant_Company_Index",
        title: "企业列表",
        component: "merchant/company/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 313,
      },
      // 添加企业信息 (id=314)
      {
        path: "/merchant/company/detail/index",
        name: "Merchant_Commpany_Detail_Insert_Index",
        title: "添加企业信息",
        component: "merchant/company_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 314,
      },
      // 编辑企业信息 (id=315)
      {
        path: "/merchant/company/detail/index/:id",
        name: "Merchant_Company_Detail_Update_Index",
        title: "编辑企业信息",
        component: "merchant/company_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 315,
      },
      // 激活码列表 (id=316)
      {
        path: "/merchant/code/index/:merch_id/:type/:merch_name",
        name: "Merchant_Code_Index",
        title: "激活码列表",
        component: "merchant/code/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 316,
      },
      // 人社列表 (id=317)
      {
        path: "/merchant/renshe/index",
        name: "Merchant_Renshe_Index",
        title: "人社列表",
        component: "merchant/renshe/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 317,
      },
      // 添加人社信息 (id=318)
      {
        path: "/merchant/renshe/detail/index",
        name: "Merchant_Renshe_Detail_Insert_Index",
        title: "添加人社信息",
        component: "merchant/renshe_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 318,
      },
      // 编辑人社信息 (id=319)
      {
        path: "/merchant/renshe/detail/index/:id",
        name: "Merchant_Renshe_Detail_Update_Index",
        title: "编辑人社信息",
        component: "merchant/renshe_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 319,
      },
      // 高校列表 (id=320)
      {
        path: "/merchant/school/index",
        name: "Merchant_School_Index",
        title: "高校列表",
        component: "merchant/school/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 320,
      },
      // 添加高校信息 (id=321)
      {
        path: "/merchant/school/detail/index",
        name: "Merchant_School_Detail_Insert_Index",
        title: "添加高校信息",
        component: "merchant/school_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 321,
      },
      // 编辑高校信息 (id=322)
      {
        path: "/merchant/school/detail/index/:id",
        name: "Merchant_School_Detail_Update_Index",
        title: "编辑高校信息",
        component: "merchant/school_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 3,
        auth: "",
        id: 322,
      },
      // 开店申请列表 (id=323)
      {
        path: "/merchant/apply/index",
        name: "Merchant_Apply_Index",
        title: "开店申请列表",
        component: "merchant/apply/index",
        icon: "el-icon-s-shop",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 323,
      },
      // 咖啡店确权用户列表 (id=324)
      {
        path: "/merchant/coffee/user/index/:shop_id",
        name: "Merchant_Coffee_User_Index",
        title: "确权用户列表",
        component: "merchant/coffee_user/index",
        icon: "ivu-icon ivu-icon-ios-cafe",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 3,
        type: 2,
        auth: "",
        id: 324,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 3,
  },

  // 用户管理 (id=4)
  {
    path: "/user",
    name: "User",
    title: "用户管理",
    component: "layout/index",
    icon: "el-icon-user",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 用户列表 (id=401)
      {
        path: "/user/index",
        name: "User_Index",
        title: "用户列表",
        component: "user/index",
        icon: "el-icon-user",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 2,
        auth: "",
        id: 401,
      },
      // 可能合伙人列表 (id=402)
      {
        path: "/merchant/partner/index",
        name: "Merchant_Partner_Index",
        title: "可能合伙人列表",
        component: "merchant/partner/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 2,
        auth: "",
        id: 402,
      },
      // 添加可能合伙人信息 (id=403)
      {
        path: "/merchant/partner/detail/index",
        name: "Merchant_Partner_Detail_Insert_Index",
        title: "添加可能合伙人信息",
        component: "merchant/partner_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 3,
        auth: "",
        id: 403,
      },
      // 编辑可能合伙人信息 (id=404)
      {
        path: "/merchant/partner/detail/index/:id",
        name: "Merchant_Partner_Detail_Update_Index",
        title: "编辑可能合伙人信息",
        component: "merchant/partner_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 3,
        auth: "",
        id: 404,
      },
      // 先知列表 (id=405)
      {
        path: "/merchant/prophet/index",
        name: "Merchant_Prophet_Index",
        title: "先知列表",
        component: "merchant/prophet/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 2,
        auth: "",
        id: 405,
      },
      // 添加先知信息 (id=406)
      {
        path: "/merchant/prophet/detail/index",
        name: "Merchant_Prophet_Detail_Insert_Index",
        title: "添加先知信息",
        component: "merchant/prophet_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 3,
        auth: "",
        id: 406,
      },
      // 编辑先知信息 (id=407)
      {
        path: "/merchant/prophet/detail/index/:id",
        name: "Merchant_Prophet_Detail_Update_Index",
        title: "编辑先知信息",
        component: "merchant/prophet_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 3,
        auth: "",
        id: 407,
      },
      // 推神列表 (id=408)
      {
        path: "/merchant/article/index",
        name: "Merchant_Article_Index",
        title: "推神列表",
        component: "merchant/article/index",
        icon: "ivu-icon ivu-icon-md-contacts",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 2,
        auth: "",
        id: 408,
      },
      // 添加推神信息 (id=409)
      {
        path: "/merchant/article/detail/index",
        name: "Merchant_Article_Detail_Insert_Index",
        title: "添加推神信息",
        component: "merchant/article_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 3,
        auth: "",
        id: 409,
      },
      // 编辑推神信息 (id=410)
      {
        path: "/merchant/article/detail/index/:id",
        name: "Merchant_Article_Detail_Update_Index",
        title: "编辑推神信息",
        component: "merchant/article_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 4,
        type: 3,
        auth: "",
        id: 410,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 4,
  },

  // 会员管理 (id=5)
  {
    path: "/awakenVip",
    name: "AwakenVip",
    title: "会员管理",
    component: "layout/index",
    icon: "ivu-icon ivu-icon-logo-angular",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 居民招募计划 (id=501)
      {
        path: "/awaken/vip/index",
        name: "Awaken_Vip_Index",
        title: "居民招募计划",
        component: "awaken/vip/index",
        icon: "ivu-icon ivu-icon-logo-angular",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 5,
        type: 2,
        auth: "",
        id: 501,
      },
      // DADA招募计划 (id=502)
      {
        path: "/awaken/dada/index",
        name: "Awaken_DADA_Index",
        title: "DADA招募计划",
        component: "awaken/vip/index",
        icon: "ivu-icon ivu-icon-logo-angular",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 5,
        type: 2,
        auth: "",
        id: 502,
      },
      // 可能合伙人招募计划 (id=503)
      {
        path: "/awaken/partner/index",
        name: "Awaken_Partner_Index",
        title: "可能合伙人招募计划",
        component: "awaken/vip/index",
        icon: "ivu-icon ivu-icon-logo-angular",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 5,
        type: 2,
        auth: "",
        id: 504,
      },
      // 极壤"企业会员"计划 (id=505)
      {
        path: "/awaken/enterprise/index",
        name: "Awaken_Enterprise_Index",
        title: '极壤"企业会员"计划',
        component: "awaken/vip/index",
        icon: "ivu-icon ivu-icon-logo-angular",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 5,
        type: 2,
        auth: "",
        id: 505,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 5,
  },

  // 觉醒管理 (id=6)
  {
    path: "/awaken",
    name: "Awaken",
    title: "觉醒管理",
    component: "layout/index",
    icon: "ivu-icon ivu-icon-logo-angular",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 测试服务 (id=601)
      {
        path: "/awaken/agreement/index",
        name: "Awaken_Agreement_Index",
        title: "测试服务",
        component: "awaken/agreement/index",
        icon: "ivu-icon ivu-icon-logo-angular",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 6,
        type: 2,
        auth: "",
        id: 601,
      },
      // 其他服务 (id=602)
      {
        path: "/awaken/article/index",
        name: "Awaken_Article_Index",
        title: "服务列表",
        component: "awaken/article/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 6,
        type: 2,
        auth: "",
        id: 602,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 6,
  },

  // SKU管理 (id=7)
  {
    path: "/store",
    name: "Store",
    title: "SKU管理",
    component: "layout/index",
    icon: "ivu-icon ivu-icon-ios-appstore",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 学院管理 (id=701)
      {
        path: "/college",
        name: "College",
        title: "学院管理",
        component: "college/init",
        icon: "el-icon-school",
        isLayout: false,
        isRouter: true,
        isMenu: true,
        children: [
          // 每日开悟列表 (id=70101)
          {
            path: "/college/article/index",
            name: "College_Article_Index",
            title: "每日开悟列表",
            component: "college/article/index",
            icon: "ivu-icon ivu-icon-md-checkmark-circle-outline",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70101,
          },
          // 添加每日开悟 (id=70102)
          {
            path: "/college/article/detail/index",
            name: "College_Article_Insert_Index",
            title: "添加每日开悟",
            component: "college/article/detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70102,
          },
          // 编辑每日开悟 (id=70103)
          {
            path: "/college/article/detail/index/:id",
            name: "College_Article_Update_Index",
            title: "编辑每日开悟",
            component: "college/article/detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70103,
          },
          // 课程分类列表 (id=70104)
          {
            path: "/college/course_class/index",
            name: "College_Course_Class_Index",
            title: "课程分类列表",
            component: "college/course_class/index",
            icon: "el-icon-help",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70104,
          },
          // 课程列表 (id=70105)
          {
            path: "/college/course/index",
            name: "College_Course_Index",
            title: "课程列表",
            component: "college/course/index",
            icon: "ivu-icon ivu-icon-md-bookmarks",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70105,
          },
          // 添加课程 (id=70106)
          {
            path: "/college/course/detail/index",
            name: "College_Course_Insert_Index",
            title: "添加课程",
            component: "college/course_detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 3,
            auth: "",
            id: 70106,
          },
          // 编辑课程 (id=70107)
          {
            path: "/college/course/detail/index/:id",
            name: "College_Course_Update_Index",
            title: "课程列表",
            component: "college/course_detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 3,
            auth: "",
            id: 70107,
          },
          // 课程章节列表 (id=70108)
          {
            path: "/college/course_chapter/index/:course_id",
            name: "College_Course_Chapter_Index",
            title: "课程章节列表",
            component: "college/course_chapter/index",
            icon: "ivu-icon ivu-icon-md-bookmarks",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 3,
            auth: "",
            id: 70108,
          },
          // 课程章节题库列表 (id=70109)
          {
            path: "/college/course_question/index/:course_id/:course_lesson_id",
            name: "College_Course_Chapter_Question_Index",
            title: "课程章节-题库列表",
            component: "college/course_question/index",
            icon: "ivu-icon ivu-icon-md-bookmarks",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 3,
            auth: "",
            id: 70109,
          },
          // 极壤先知列表 (id=70110)
          {
            path: "/user/teacher/index",
            name: "User_Teacher_Index",
            title: "极壤先知列表",
            component: "user/teacher/index",
            icon: "ivu-icon ivu-icon-ios-people",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70110,
          },
          // 呼叫记录列表 (id=70111)
          {
            path: "/user/teacher/record/index/:id",
            name: "User_Teacher_Record_Index",
            title: "呼叫记录列表",
            component: "user/teacher_record/index",
            icon: "ivu-icon ivu-icon-ios-people",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 701,
            type: 2,
            auth: "",
            id: 70111,
          },
        ],
        role: [],
        parentId: 7,
        type: 1,
        auth: "",
        id: 701,
      },
      // 咖啡管理 (id=702)
      {
        path: "/coffee",
        name: "Coffee",
        title: "咖啡管理",
        component: "coffee/init",
        icon: "ivu-icon ivu-icon-ios-cafe-outline",
        isLayout: false,
        isRouter: true,
        isMenu: true,
        children: [
          // 分类列表 (id=70201)
          {
            path: "/coffee/class/index",
            name: "Coffee_Class_Index",
            title: "分类列表",
            component: "coffee/class/index",
            icon: "ivu-icon ivu-icon-ios-color-filter",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 702,
            type: 2,
            auth: "",
            id: 70201,
          },
          // 咖啡列表 (id=70202)
          {
            path: "/coffee/index",
            name: "Coffee_Index",
            title: "咖啡列表",
            component: "coffee/index",
            icon: "ivu-icon ivu-icon-ios-cafe",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 702,
            type: 2,
            auth: "",
            id: 70202,
          },
          // 添加咖啡信息 (id=70203)
          {
            path: "/coffee/detail/index",
            name: "Coffee_Detail_Insert_Index",
            title: "添加咖啡信息",
            component: "coffee/detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 702,
            type: 3,
            auth: "",
            id: 70203,
          },
          // 编辑咖啡信息 (id=70204)
          {
            path: "/coffee/detail/index/:id",
            name: "Coffee_Detail_Update_Index",
            title: "编辑咖啡信息",
            component: "coffee/detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 702,
            type: 3,
            auth: "",
            id: 70204,
          },
        ],
        role: [],
        parentId: 7,
        type: 1,
        auth: "",
        id: 702,
      },
      // 活动管理 (id=703)
      {
        path: "/activity",
        name: "Activity",
        title: "活动管理",
        component: "activity/init",
        icon: "ivu-icon ivu-icon-ios-ionic-outline",
        isLayout: false,
        isRouter: true,
        isMenu: true,
        children: [
          // 全部活动列表 (id=70301)
          {
            path: "/activity/index",
            name: "Activity_Index",
            title: "全部活动列表",
            component: "activity/index",
            icon: "ivu-icon ivu-icon-md-ionic",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 2,
            auth: "",
            id: 70301,
          },
          // 添加全部活动 (id=70302)
          {
            path: "/activity/detail/index",
            name: "Activity_Insert_Detail_Index",
            title: "添加全部活动",
            component: "activity/detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 3,
            auth: "",
            id: 70302,
          },
          // 编辑全部活动 (id=70303)
          {
            path: "/activity/detail/index/:id",
            name: "Activity_Update_Detail_Index",
            title: "编辑全部活动",
            component: "activity/detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 3,
            auth: "",
            id: 70303,
          },
          // 可能活动列表 (id=70304)
          {
            path: "/week_activity/index",
            name: "Week_Activity_Index",
            title: "可能活动列表",
            component: "activity/week_activity/index",
            icon: "ivu-icon ivu-icon-ios-ionic",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 2,
            auth: "",
            id: 70304,
          },
          // 添加可能活动 (id=70305)
          {
            path: "/week_activity/detail/index",
            name: "Week_Activity_Insert_Detail_Index",
            title: "添加可能活动",
            component: "activity/week_activity/detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 3,
            auth: "",
            id: 70305,
          },
          // 编辑可能活动 (id=70306)
          {
            path: "/week_activity/detail/index/:id",
            name: "Week_Activity_Update_Detail_Index",
            title: "编辑可能活动",
            component: "activity/week_activity/detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 3,
            auth: "",
            id: 70306,
          },
          // 可能活动-报名记录 (id=70307)
          {
            path: "/week_activity/record/index/:id",
            name: "Week_Activity_Record_Index",
            title: "报名记录列表",
            component: "activity/week_activity/record/index",
            icon: "el-icon-suitcase",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 2,
            auth: "",
            id: 70307,
          },
          // 可能活动-认领列表 (id=70308)
          {
            path: "/week_activity/apply/index/:id",
            name: "Week_Activity_Apply_Index",
            title: "活动认领列表",
            component: "activity/week_activity/apply/index",
            icon: "el-icon-suitcase",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 2,
            auth: "",
            id: 70308,
          },

          // 未来教室
          // 未来教室列表 (id=70309)
          {
            path: "/party/index",
            name: "Party_Index",
            title: "未来教室列表",
            component: "activity/party/index",
            icon: "ivu-icon ivu-icon-ios-ionic",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 2,
            auth: "",
            id: 70309,
          },
          // 添加未来教室 (id=70310)
          {
            path: "/party/detail/index",
            name: "Party_Insert_Detail_Index",
            title: "添加未来教室",
            component: "activity/party/detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 3,
            auth: "",
            id: 70310,
          },
          // 编辑未来教室 (id=70311)
          {
            path: "/party/detail/index/:id",
            name: "Party_Update_Detail_Index",
            title: "编辑未来教室",
            component: "activity/party/detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 3,
            auth: "",
            id: 70311,
          },
          // 未来教室-报名记录 (id=70312)
          {
            path: "/party/record/index/:id",
            name: "Party_Record_Index",
            title: "报名记录列表",
            component: "activity/party/record/index",
            icon: "el-icon-suitcase",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 703,
            type: 2,
            auth: "",
            id: 70312,
          },
          // 未来教室-认领列表 (id=70313)
          // {
          //   path: "/party/apply/index/:id",
          //   name: "Party_Apply_Index",
          //   title: "未来教室认领列表",
          //   component: "activity/party/apply/index",
          //   icon: "el-icon-suitcase",
          //   isRouter: true,
          //   isMenu: false,
          //   isLayout: false,
          //   children: [],
          //   role: [],
          //   parentId: 703,
          //   type: 2,
          //   auth: "",
          //   id: 70313,
          // },
        ],
        role: [],
        parentId: 7,
        type: 1,
        auth: "",
        id: 703,
      },
      // 数字游民
      // 青年offer (id=704)
      {
        path: "/party",
        name: "Party",
        title: "青年offer",
        component: "party/init",
        icon: "ivu-icon ivu-icon-ios-cafe-outline",
        isLayout: false,
        isRouter: true,
        isMenu: true,
        children: [
          // 门店列表 (id=70201)
          {
            path: "/party/shop/index",
            name: "Party_Shop_Index",
            title: "门店列表",
            component: "party/shop/index",
            icon: "ivu-icon ivu-icon-ios-color-filter",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 2,
            auth: "",
            id: 70401,
          },
          // 添加门店信息 (id=70405)
          {
            path: "/party/shop/detail/index",
            name: "Party_Shop_Detail_Insert_Index",
            title: "添加门店",
            component: "party/shop_detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 3,
            auth: "",
            id: 70405,
          },
          // 编辑门店信息 (id=70406)
          {
            path: "/party/shop/detail/index/:id",
            name: "Party_Shop_Detail_Update_Index",
            title: "编辑门店信息",
            component: "party/shop_detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 3,
            auth: "",
            id: 70406,
          },
          // 工位列表 (id=70402)
          {
            path: "/party/product/index",
            name: "Party_Product_Index",
            title: "工位列表",
            component: "party/product/index",
            icon: "ivu-icon ivu-icon-ios-cafe",
            isRouter: true,
            isMenu: true,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 2,
            auth: "",
            id: 70402,
          },
          // 添加工位信息 (id=70403)
          {
            path: "/party/product/detail/index",
            name: "Party_Product_Detail_Insert_Index",
            title: "添加工位",
            component: "party/product/detail/index",
            icon: "el-icon-plus",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 3,
            auth: "",
            id: 70403,
          },
          // 编辑工位信息 (id=70404)
          {
            path: "/party/product/detail/index/:id",
            name: "Party_Product_Detail_Update_Index",
            title: "编辑工位信息",
            component: "party/product/detail/index",
            icon: "el-icon-check",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 3,
            auth: "",
            id: 70404,
          },
          // 工位价格表 (id=70407)
          {
            path: "/party/product/price/index/:product_id",
            name: "Party_Product_Price_Index",
            title: "工位价格表",
            component: "party/product/price/index",
            icon: "ivu-icon ivu-icon-ios-cafe",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 2,
            auth: "",
            id: 70407,
          },
          // 青年offer 确权用户列表 (id=70408)
          {
            path: "/party/shop/user/index/:shop_id",
            name: "Party_Shop_User_Index",
            title: "确权用户列表",
            component: "party/shop_user/index",
            icon: "ivu-icon ivu-icon-ios-cafe",
            isRouter: true,
            isMenu: false,
            isLayout: false,
            children: [],
            role: [],
            parentId: 704,
            type: 2,
            auth: "",
            id: 70408,
          },
        ],
        role: [],
        parentId: 7,
        type: 1,
        auth: "",
        id: 704,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 7,
  },

  // 市集管理 (id=8)
  {
    path: "/vagrant",
    name: "Vagrant",
    title: "市集管理",
    component: "layout/index",
    icon: "el-icon-office-building",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 信息列表 (id=801)
      {
        path: "/vagrant/index",
        name: "Vagrant_Index",
        title: "信息列表",
        component: "vagrant/index",
        icon: "el-icon-suitcase",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 8,
        type: 2,
        auth: "",
        id: 801,
      },
      // 添加市集信息 (id=802)
      {
        path: "/vagrant/detail/index",
        name: "Vagrant_Insert_Index",
        title: "添加市集信息",
        component: "vagrant/detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 8,
        type: 3,
        auth: "",
        id: 802,
      },
      // 编辑市集信息 (id=803)
      {
        path: "/vagrant/detail/index/:id",
        name: "Vagrant_Update_Index",
        title: "编辑市集信息",
        component: "vagrant/detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 8,
        type: 3,
        auth: "",
        id: 803,
      },
      // 报名记录 (id=804)
      {
        path: "/vagrant/record/index/:id",
        name: "Vagrant_Record_Index",
        title: "报名记录列表",
        component: "vagrant/record/index",
        icon: "el-icon-suitcase",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 8,
        type: 2,
        auth: "",
        id: 804,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 8,
  },

  // 帖子管理 (id=9)
  {
    path: "/article",
    name: "Article",
    title: "帖子管理",
    component: "layout/index",
    icon: "el-icon-news",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 帖子列表 (id=901)
      {
        path: "/article/index",
        name: "Article_Index",
        title: "帖子列表",
        component: "article/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 9,
        type: 2,
        auth: "",
        id: 901,
      },
      // 添加帖子 (id=902)
      {
        path: "/article/detail/index",
        name: "Article_Insert_Index",
        title: "添加帖子",
        component: "article/detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 9,
        type: 3,
        auth: "",
        id: 902,
      },
      // 编辑帖子 (id=903)
      {
        path: "/article/detail/index/:id",
        name: "Article_Update_Index",
        title: "编辑帖子",
        component: "article/detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 9,
        type: 3,
        auth: "",
        id: 903,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 9,
  },

  // 人社管理 (id=10)
  {
    path: "/renshe",
    name: "Renshe",
    title: "人社管理",
    component: "layout/index",
    icon: "el-icon-news",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 文章列表 (id=1001)
      {
        path: "/renshe/article/index",
        name: "Renshe_Article_Index",
        title: "文章列表",
        component: "renshe/article/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1001,
      },
      // 添加帖子 (id=1002)
      {
        path: "/renshe/article/detail/index",
        name: "Renshe_Article_Insert_Index",
        title: "添加文章",
        component: "renshe/article_detail/index",
        icon: "el-icon-plus",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 3,
        auth: "",
        id: 1002,
      },
      // 编辑帖子 (id=1003)
      {
        path: "/renshe/article/detail/index/:id",
        name: "Renshe_Article_Update_Index",
        title: "编辑文章",
        component: "renshe/article_detail/index",
        icon: "el-icon-check",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 3,
        auth: "",
        id: 1003,
      },
      // 文章浏览记录 (id=1004)
      {
        path: "/renshe/article/record/index/:id",
        name: "Renshe_Article_Record_Index",
        title: "文章浏览记录",
        component: "renshe/article_record/index",
        icon: "el-icon-view",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 3,
        auth: "",
        id: 1004,
      },
      // 文章报名记录 (id=1005)
      {
        path: "/renshe/article/apply/index/:id",
        name: "Renshe_Article_Apply_Index",
        title: "文章报名记录",
        component: "renshe/article_apply/index",
        icon: "el-icon-s-order",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 3,
        auth: "",
        id: 1005,
      },

      // 智能测试 (id=1006)
      {
        path: "/renshe/test/index",
        name: "Renshe_Test_Index",
        title: "智能测试",
        component: "renshe/test/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1006,
      },

      // 智能测试记录 (id=1007)
      {
        path: "/renshe/test/record/index/:id",
        name: "Renshe_Test_Record_Index",
        title: "智能测试记录",
        component: "renshe/test_record/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1007,
      },

      // 智能测试记录详情 (id=1008)
      {
        path: "/renshe/test/record/detail/index",
        name: "Renshe_Test_Record_Detail",
        title: "智能测试记录详情",
        component: "renshe/test_detail/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1008,
      },

      // 智能测试记录报告 (id=1009)
      {
        path: "/renshe/test/record/report/index",
        name: "Renshe_Test_Record_Report",
        title: "智能测试记录报告",
        component: "renshe/test_report/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1009,
      },

      // 模拟面试 (id=1010)
      {
        path: "/renshe/interview/index",
        name: "Renshe_Interview_Index",
        title: "模拟面试",
        component: "renshe/interview/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1010,
      },

      // 模拟面试记录 (id=1011)
      {
        path: "/renshe/interview/record/index/:id",
        name: "Renshe_Interview_Record_Index",
        title: "智能测试记录",
        component: "renshe/interview_record/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1011,
      },

      // 模拟面试记录报告 (id=1012)
      {
        path: "/renshe/interview/record/report/index",
        name: "Renshe_Interview_Record_Report",
        title: "模拟面试记录报告",
        component: "renshe/interview_report/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1012,
      },

      // 简历大师列表 (id=1013)
      {
        path: "/renshe/resume/index",
        name: "Renshe_Resume_Index",
        title: "简历大师",
        component: "renshe/resume/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1013,
      },

      // 简历分析记录 (id=1014)
      {
        path: "/renshe/resume/record/index/:id",
        name: "Renshe_Resume_Record_Index",
        title: "简历分析记录",
        component: "renshe/resume_record/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1014,
      },

      // 简历分析报告 (id=1015)
      {
        path: "/renshe/resume/record/report/index",
        name: "Renshe_Resume_Record_Report",
        title: "简历分析报告",
        component: "renshe/resume_report/index",
        icon: "el-icon-news",
        isRouter: true,
        isMenu: false,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1015,
      },

      // 用户列表 (id=1016)
      {
        path: "/renshe/user/index",
        name: "Renshe_User_Index",
        title: "用户列表",
        component: "renshe/user/index",
        icon: "el-icon-user",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1016,
      },

      // 隐私协议 (id=1017)
      {
        path: "/renshe/setting/index",
        name: "Renshe_Setting_Index",
        title: "隐私协议",
        component: "renshe/setting/index",
        icon: "el-icon-setting",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 10,
        type: 2,
        auth: "",
        id: 1017,
      },
    ],
    role: [],
    parentId: 0,
    type: 1,
    auth: "",
    id: 10,
  },
];
